import React from 'react'
import SideNavbar from '../../components/side_navBar'
import NavBar from '../../components/nav_bar'
import { Outlet } from 'react-router-dom'
import { usePreloadImages } from 'src/API/preloadImage'
import { ProtectedRoute } from 'src/components/protected_route'

export function LayoutRoot() {
  return (
    <ProtectedRoute>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
        <div className="flex h-screen overflow-hidden">
          {/* Sidebar with glassmorphism effect */}
          <div className="h-full">
            <SideNavbar />
          </div>
          
          {/* Main content area */}
          <div className="flex flex-col flex-1 overflow-hidden">
            {/* Navbar with glassmorphism effect */}
            <div className="h-16 border-b border-gray-200 dark:border-gray-700 bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg">
              <NavBar />
            </div>
            
            {/* Main content with proper padding and scrolling */}
            <main className="flex-1 overflow-y-auto p-6">
              <div className="max-w-7xl mx-auto">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  )
}
